import { FC, useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import {
  getPodrOrders,
  selectUpdateStoksPodruzhkaStore,
} from "../../app/reducers/updateStoksPodruzhka"
import { DataTable, type DataTableColumn } from "../DataTable/DataTable"
import { Select } from "../Select/Select"

type PodrItem = {
  id: string
  name: string
  quantity: number
  price: string
}

type SummaryRow = {
  id: ""
  name: ""
  quantity: number
  price: string
  _summary: true
  value: number | undefined
}

export const PodrOrders: FC = () => {
  const dispatch = useAppDispatch()
  const updateStoksStore = useAppSelector(selectUpdateStoksPodruzhkaStore)
  const { orders } = updateStoksStore
  const [selectedOrder, setSelectedOrder] = useState<string>("")
  useEffect(() => {
    dispatch(getPodrOrders())
  }, [dispatch])

  const ordersList = Object.keys(orders || {})
  const items = orders?.[selectedOrder]?.items ?? []
  const summaryValue = orders?.[selectedOrder]?.value
  const tableData: (PodrItem | SummaryRow)[] = [
    ...items,
    {
      id: "",
      name: "",
      quantity: 0,
      price: "",
      _summary: true,
      value: summaryValue,
    },
  ]

  const columns: DataTableColumn<PodrItem | SummaryRow>[] = [
    { key: "id", header: "Артикул подружки" },
    { key: "name", header: "Название" },
    { key: "quantity", header: "количество" },
    {
      key: "price",
      header: "цена",
      cell: (row) =>
        "_summary" in row && row._summary ? (
          <b>{row.value}</b>
        ) : (
          Number.parseFloat(row.price)
        ),
    },
  ]

  return (
    <div>
      <h5>Заказы Подружка</h5>
      <Select
        value={selectedOrder || ""}
        onChange={(value) => {
          setSelectedOrder(value)
        }}
        options={ordersList.map((date) => ({
          value: date,
          label: new Date(+date).toLocaleString(),
        }))}
        placeholder="Выбрать дату заказа"
        clearable
      />
      <div>
        <DataTable
          columns={columns}
          data={tableData}
          rowKey={(row, i) =>
            "_summary" in row && row._summary ? "summary" : row.id + "-" + i
          }
        />
      </div>
    </div>
  )
}
